import Component from "@glimmer/component";
import RadioCheckboxTile from "glesys-controlpanel/components/radio-checkbox-tile";
import Select, { Option } from "glesys-controlpanel/components/select";
import Box from "glesys-controlpanel/components/box";
import IconsCheckCircle from "glesys-controlpanel/components/icons/check-circle";
import { t } from "ember-intl";
import { on } from "@ember/modifier";

const Plan = class extends Component {
  onStorageChange = (event) => {
    const selected = this.args.plan.storage.find((storage) => storage.key === event.target.value);
    this.args.onChange({ ...this.args.plan, selected });
  };

  <template>
    <div
      class="grid grid-rows-[1fr_auto] gap-4 rounded-lg border overflow-hidden h-full hover:border-gray-300 has-[input:checked]:border-black has-[input:checked]:hover:border-black has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-blue-700 has-[input:focus-visible]:ring-offset-2"
      data-test-select-plan={{@plan.key}}
    >
      <RadioCheckboxTile
        class="border-0 rounded-none items-start grid gap-4 w-full has-focus-visible:ring-0 has-focus-visible:ring-offset-0"
        data-test-select-plan-radio
        @group="database-plan"
        @value={{@plan}}
        @selected={{@selected}}
        @key="key"
        @onChange={{@onChange}}
      >
        <p class="text-lg">
          {{t "databases.create.plans.configuration" cpu=@plan.cpucores memory=@plan.memoryingib}}
        </p>
        <ul class="text-gray-700">
          <li class="flex items-center gap-1"><IconsCheckCircle class="h-4" />
            {{t "databases.create.plans.cpu-cores" amount=@plan.cpucores}}
          </li>
          <li class="flex items-center gap-1"><IconsCheckCircle class="h-4" />
            {{@plan.memoryingib}}
            GiB
          </li>
        </ul>
      </RadioCheckboxTile>
      <Select
        class="rounded-none border-0 border-t bg-transparent"
        aria-label={{t "databases.create.plans.select-storage-size-label"}}
        data-test-select-plan-storage
        @value={{@plan.selected.key}}
        {{on "change" this.onStorageChange}}
      >
        {{#each @plan.storage as |storage|}}
          <Option value={{storage.key}}>{{t "databases.create.plans.storage" storage=storage.storageingib}}</Option>
        {{/each}}
      </Select>
    </div>
  </template>
};

<template>
  <Box>
    <:header>{{t "label.plans"}}</:header>
    <:default>
      <div class="grid grid-cols-1 @lg:grid-cols-3 gap-4">
        {{#each @plans as |plan|}}
          <Plan @plan={{plan}} @onChange={{@onChange}} @selected={{@selected}} />
        {{/each}}
      </div>
    </:default>
  </Box>
</template>
